import customFetch from '../../../utils/customFetch';

export const getClaimInfo = id => {
  return customFetch('/PatientInfo/ClaimantInfo', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
};

export const checkDuplicateLastName = (id, lastName) => {
  return customFetch('/PatientInfo/CheckDuplicateName', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, lastName }),
  });
};

export const checkDuplicateEmail = (id, email) => {
  return customFetch('/PatientInfo/CheckDuplicateEmail', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, email }),
  });
};

export const saveClaimant = body => {
  return customFetch('/PatientInfo/Save', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
};

export const getAssessmentHistory = id => {
  return customFetch('/PatientInfo/GetPatientAppointmentHistory', {
    method: 'POST',
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify({
      id: id,
    }),
  });
};
